import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import store from './redux/store';
import LandingPage from './components/LandingPage';
import Onboarding from './components/Onboarding';
import OTPVerification from './components/OTPVerification';
import ProfileCompletion from './components/ProfileCompletion';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import SafetyPolicy from './components/SafetyPolicy';
import DeleteAccount from './components/DeleteAccount';

function AppContent() {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path="/" element={<LandingPage onNavigateToOnboarding={() => navigate('/onboarding')} />} />
      <Route path="/onboarding" element={<Onboarding onBack={() => navigate('/')} />} />
      <Route path="/verify-otp" element={<OTPVerification onBack={() => navigate('/onboarding')} />} />
      <Route path="/complete-profile" element={<ProfileCompletion />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/safety-policy" element={<SafetyPolicy />} />
      <Route path="/how-to/delete-account" element={<DeleteAccount />} />
      <Route path="*" element={<Navigate to="/" replace />}/>
    </Routes>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
